import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../types'
import { CmsConverterService } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PortfolioOverviewConverter extends CmsConverterService<PortfolioOverviewData> {
  convertData (source: CmsComponent) {
    return {}
  }
}

export const PORTFOLIO_OVERVIEW_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, PortfolioOverviewConverter>>('PortfolioOverviewConverter')

export type PortfolioOverviewData = ConvertedComponentData
